<template>
    <Loading>
        <div class="profile-skeleton-root p-3">
            <div class="d-flex align-items">
                <Avatar class="mr-2" />
                <div
                    class="flex-grow d-flex flex-column justify-content-center"
                >
                    <Row class="w-100" />
                    <Row class="w-50 m-0" />
                </div>
            </div>
            <Divider class="my-3" />
            <div class="d-flex flex-column align-items-center">
                <Row />
                <Row />
                <Row class="textbox mt-2" />

                <Row class="button mt-5" />
            </div>
        </div>
    </Loading>
</template>

<script>
import Loading from './base/Loading';
import Avatar from './base/Avatar';
import Row from './base/Row';

export default {
    name: 'ProfileModuleSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.profile-skeleton-root {
}
.textbox {
    height: 80px;
}
.button {
    height: 38px;
    border-radius: 3px;
}
</style>
